import ProgressDot from './ProgressDot';

export default ProgressDot;